var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCameraImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1502_2214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.22651 3.28364L5.59327 4.91688H2.46723V14.7164H15.5332V4.91688H12.4072L10.7739 3.28364H7.22651ZM6.55035 1.65039H11.4501L13.0833 3.28364H16.3498C16.5664 3.28364 16.7741 3.36967 16.9273 3.52282C17.0804 3.67597 17.1665 3.88368 17.1665 4.10026V15.533C17.1665 15.7496 17.0804 15.9573 16.9273 16.1104C16.7741 16.2636 16.5664 16.3496 16.3498 16.3496H1.65061C1.43403 16.3496 1.22631 16.2636 1.07317 16.1104C0.920021 15.9573 0.833984 15.7496 0.833984 15.533V4.10026C0.833984 3.88368 0.920021 3.67597 1.07317 3.52282C1.22631 3.36967 1.43403 3.28364 1.65061 3.28364H4.9171L6.55035 1.65039Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.99943 12.7762C8.10603 12.7762 7.24922 12.4213 6.61749 11.7896C5.98576 11.1578 5.63086 10.301 5.63086 9.40763C5.63086 8.51423 5.98576 7.65742 6.61749 7.02569C7.24922 6.39396 8.10603 6.03906 8.99943 6.03906C9.89283 6.03906 10.7496 6.39396 11.3814 7.02569C12.0131 7.65742 12.368 8.51423 12.368 9.40763C12.368 10.301 12.0131 11.1578 11.3814 11.7896C10.7496 12.4213 9.89283 12.7762 8.99943 12.7762ZM8.99943 11.5513C9.56796 11.5513 10.1132 11.3254 10.5152 10.9234C10.9172 10.5214 11.1431 9.97616 11.1431 9.40763C11.1431 8.83911 10.9172 8.29386 10.5152 7.89185C10.1132 7.48984 9.56796 7.264 8.99943 7.264C8.4309 7.264 7.88566 7.48984 7.48365 7.89185C7.08164 8.29386 6.85579 8.83911 6.85579 9.40763C6.85579 9.97616 7.08164 10.5214 7.48365 10.9234C7.88566 11.3254 8.4309 11.5513 8.99943 11.5513Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1502_2214"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraImg);
export default __webpack_public_path__ + "static/media/cameraImg.d532d1180028e40eb5c0ae067afc0ffe.svg";
export { ForwardRef as ReactComponent };